import React, { useState, useContext, useEffect } from "react";
import {
  Dialog,
  Text,
  Flex,
  Button,
  Box,
  RadioCards,
  Badge,
} from "@radix-ui/themes";
import { loadStripe } from "@stripe/stripe-js";
import api from "axios_interceptor/interceptor";
import { UserInfoContext } from "context/UserInfoContext";
import axios from "axios";
const key =
  window.location.hostname === "localhost"
    ? process.env.REACT_APP_STRIPE_KEY
    : process.env.REACT_APP_STRIPE_KEY_PROD;
const stripePromise = loadStripe(key);

// "price_1Qtq3GRv1q8Gkf93CsOWaQXv": $1
// "price_1Qtq41Rv1q8Gkf93aezsxOYF": $3
// "price_1Qtq2NRv1q8Gkf93O2PfCGGE": $5

// price_1PzaG5Rv1q8Gkf936SuVHgTr for test 

const PaymentDialog = () => {
  const [selectedValue, setSelectedValue] = useState(
    // "price_1PzaG5Rv1q8Gkf936SuVHgTr"
    "price_1Qtq41Rv1q8Gkf93aezsxOYF"
  );
  const [productList, setProductList] = useState([]);

  const { currentUserInfo } = useContext(UserInfoContext);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BE_URL + "/payment/product-list")
      .then((response) => {
        setProductList(
          response.data.content.sort((a, b) => a.unit_amount - b.unit_amount)
        );
      })
      .catch((error) => {
        console.error("Error fetching product list:", error);
      });
  }, []);

  const handleValueChange = (value) => {
    setSelectedValue(value);
  };

  const handleBuyClick = async () => {
    try {
      const response = await api.post("/payment/create-payment-session", {
        price_id: selectedValue,
      });

      const stripe = await stripePromise;
      const { error } = await stripe.redirectToCheckout({
        sessionId: response.data.session,
      });

      if (error) {
        console.error("Stripe Checkout error:", error);
      }
    } catch (error) {
      console.error("Error creating payment session:", error);
    }
  };

  return (
    <div>
      <Dialog.Root>
        <Dialog.Trigger>
          <Button
            size="2"
            variant="soft"
            color="green"
            style={{ width: "100px", cursor: "pointer" }}
          >
            Buy tokens
          </Button>
        </Dialog.Trigger>

        <Dialog.Content maxWidth="600px">
          <Dialog.Title>Buy tokens</Dialog.Title>
          <Dialog.Description size="2" mb="2">
            Purchase tokens to create additional audio. Currently you have:
            <Badge color="orange">{currentUserInfo.count}</Badge>
          </Dialog.Description>
          <Dialog.Description size="2" mb="4">
            Prices are in{" "}
            <Text color="orange" weight="bold">
              U.S. Dollars
            </Text>
          </Dialog.Description>

          <Box maxWidth="600px">
            <RadioCards.Root
              defaultValue="price_1Qtq41Rv1q8Gkf93aezsxOYF"
              columns={{ initial: "1", sm: "3" }}
              onValueChange={handleValueChange}
              color="orange"
            >
              {productList.map((product, i) => (
                <RadioCards.Item
                  value={product.default_price}
                  style={{ cursor: "pointer" }}
                  key={i}
                >
                  <Flex direction="column" width="100%" align="center">
                    <Text weight="bold" color="green" size="8">
                      $ {product.unit_amount / 100}
                    </Text>
                    <Text color="orange" size="3">
                      {product.count_number} Tokens
                    </Text>
                  </Flex>
                </RadioCards.Item>
              ))}
            </RadioCards.Root>
          </Box>
          <Flex gap="3" mt="4" justify="end">
            <Dialog.Close>
              <Button variant="soft" color="gray" style={{ cursor: "pointer" }}>
                Cancel
              </Button>
            </Dialog.Close>
            <Dialog.Close>
              <Button
                color="green"
                style={{ cursor: "pointer" }}
                onClick={handleBuyClick}
              >
                Buy
              </Button>
            </Dialog.Close>
          </Flex>
        </Dialog.Content>
      </Dialog.Root>
    </div>
  );
};

export default PaymentDialog;
